import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { SubsetSuggestion } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetSuggestion = (suggestionId: string | null) => {
  const { matterId } = useParams<{ matterId: string }>();
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<SubsetSuggestion | null>(
    [QueryEntity.SubsetSuggestion, { matterId, suggestionId }],
    async () => {
      if (!suggestionId) return null;

      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/suggestions/${suggestionId}`,
        fetchConfigGET,
      );
      if (!res.ok) {
        throw new Error('Failed to fetch suggestion');
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!suggestionId,
    },
  );
};
